interface IEmploymentFormsWrapper {
    children: any,
    closeForm: () => void;
}

export const EmploymentFormsWrapper = ({closeForm, children}: IEmploymentFormsWrapper) => {
    return (
        <div className="card card-body mb-4 fade-in-medium">
            <div className="collapse fade show" id="collapseEmploymentEdit">
                <span className="is-icon-close d-none d-sm-block position-absolute" style={{zIndex: "50"}} role="button"
                      onClick={() => closeForm()}>
                    <svg id="icon-close" viewBox="0 0 1024 1024"><path
                        d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"
                        fill="#ccc" strokeWidth={0}/></svg>
                </span>
                <div className="row">
                    <div className="col-12">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
}